import { QuestionnaireDetailsService } from './../../../service/questionnaire/questionnaire.service';
import { IReportsFilterModel } from './../../models/reports-filter.models';
import { ConfigurationService } from './../../../configurations/configurationService';
import { ReportsQuestionaireRoutes } from './../../models/reports-questionaire.enums';
import { LazyLoadEvent } from 'primeng/api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ReportService } from '../../reportService';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from '../../models/reports-data-service-model';
import { DataService } from '../../dataService';
import { IReportsColumnModel } from '../../models/reports.models';

@Component({
    selector: 'app-reports-questionaire',
    templateUrl: './reports-questionaire.component.html',
    styleUrls: ['./reports-questionaire.component.scss']
})
export class ReportsQuestionaireComponent implements OnInit, OnDestroy {

    subscription: Subscription = new Subscription();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    //#region Properties
    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any;
    public dateTo: any;
    public dateFilterLabel: string = "All Time";
    public reportDate: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public selectedDateQuestionChannelfilter = { name: "All", id: 0 };
    public selectedDateModuleFilter = { name: 'All', id: 0 };
    public selectedDateCategoryFilter = { name: 'All', id: 0 };
    public selectedDateAccountNameFilter = { businessName: "All", id: 0 };

    public showRows = 15;
    public pageSize = 15;
    public pageNumber = 0;
    public Months: any[] = [];
    public cols: IReportsColumnModel[] = [];
    public filterByInputValue: any = [];
    public selectedFilterGroup: IReportsFilterModel[] = [];
    public reportsData = [];
    public totalRecords: number;
    public totalPages: number;
    public results = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    public OrganizationName = "";

    public dropdownAnsReports: any = [];
    public allQuestionnaireChannels: any[] = [];
    public selectedQuestionnaireChannel: any = null;
    public questionnaireChartData: any = null;
    loadingQuestionnaireText: string = "Loading...";

    filterDataByTime: any = [];
    selectedDateFilter: any = null;
    changeDateEnable = false;
    activityType: string = null;

    //#endregion
    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private service: ConfigurationService,
        private dataService: DataService,
        private questionnaireDetailsService: QuestionnaireDetailsService
    ) {
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                // if (data.value == ReportsTopMenuItemsValues.print) {
                //     this.print();
                // }
                // else if (data.value == ReportsTopMenuItemsValues.PDF) {
                //     this.exportPDF(this.selectedWindow, false);
                // }
                // else if (data.value == ReportsTopMenuItemsValues.XLS) {
                //     this.exportXLS(this.selectedWindow)
                // }
                // else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                //     this.exportXLSX(this.selectedWindow)
                // }
                if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.loadQuestionnaireReport();
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    ngOnInit(): void {

        this.subscription = this.router.paramMap.subscribe((param: any) => {
            this.activityType = param.params.type;
            this.loadQuestionnaireReport();
        });
    }

    loadQuestionnaireReport(){
        this.selectedWindow = "";
        this.selectedFilterGroup = [];
        this.filterDataByTime = [];
        this.selectedDateFilter = null;
        this.changeDateEnable = false;
        switch (this.activityType) {
            case ReportsQuestionaireRoutes.questionareDetail:
                this.selectedWindow = "questionareDetail";

                this.cols = [
                    { id: 1, field: 'businessName', header: 'Business Name', dataType: 'string' },
                    { id: 2, field: 'responses', header: 'Responses', dataType: 'string' },
                    { id: 3, field: 'comment', header: 'Comment', dataType: 'string' },
                    { id: 4, field: 'repName', header: 'Rep Name', dataType: 'string' },
                    { id: 5, field: 'visitType', header: 'Visit Type', dataType: 'string' },
                    { id: 6, field: 'imageURL', header: 'ImageURL', dataType: 'string' },
                    { id: 7, field: 'timeSpent', header: 'Time Spent', dataType: 'string' },
                    { id: 8, field: 'startTime', header: 'Start Date Time', dataType: 'string' },
                    { id: 9, field: 'endTime', header: 'End Date Time', dataType: 'string' },
                    { id: 10, field: 'channel', header: 'Channel Name', dataType: 'string' },
                    { id: 12, field: 'territoryName', header: 'Territory Name', dataType: 'string' },
                    { id: 13, field: 'moduleName', header: 'Module Name', dataType: 'string' },

                ];

                const selectedUser = this.selectedRepFilter;
                this.dateFrom = new Date();
                this.dateTo = new Date();
                this.QuestionareReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, selectedUser, this.app.companyId);
                break;
            case ReportsQuestionaireRoutes.qChannel:
                this.selectedWindow = "qChannel";
                this.cols = [
                    { id: 1, field: 'name', header: 'Questionnaire', dataType: 'string' }
                ];

                this.filterDataByTime = [
                    { label: 'Today', code: 'today' },
                    { label: 'Yesterday', code: 'yesterday' },
                    { label: 'This Month', code: 'this month' },
                    { label: 'Last Month', code: 'last month' },
                    { label: 'Last 7 days', code: 'last 7 days' },
                    { label: 'Last 15 days', code: 'last 15 days' },
                    { label: 'Last 30 days', code: 'last 30 days' },
                    { label: 'Last 60 days', code: 'last 60 days' },
                    { label: 'Last 90 days', code: 'last 90 days' },
                    { label: 'All Time', code: 'alltime' },
                    { label: 'Custom', code: 'custom' },
                ];
                this.selectedDateFilter = { label: 'All Time', code: 'alltime' };

                this.dateFrom = null;
                this.dateTo = null;
                this.changeDateEnable = true;
                this.getQuestionnaireChannels();
                break;
            default:
                break;
        }

        this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
    }

    getQuestionnaireChannels() {
        this.appMainService.isShowSpinner('loadChannels')
        this.questionnaireDetailsService.activeSurveyList().subscribe({
            next: (response)=>{
                let data = response||[];
                this.allQuestionnaireChannels = data||[];
                if (this.allQuestionnaireChannels.length > 0) {
                    this.selectedQuestionnaireChannel = this.allQuestionnaireChannels[0];
                    this.filterByInputValue = [...this.allQuestionnaireChannels];

                    this.selectedFilterGroup = [{
                        id: 1,
                        field: this.cols[0].field,
                        categoryId: this.cols[0].id,
                        category: this.cols[0].header,
                        selectedId: this.selectedQuestionnaireChannel.id,
                        nameId: '1',
                        notRemovable: true,
                        value: this.selectedQuestionnaireChannel.name,
                        previewValue: this.selectedQuestionnaireChannel.name,
                        dataType: 'string'
                    }];
                    this.getQuestionnaireChartReports();
                }
                this.appMainService.isHideSpinner('loadChannels');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('loadChannels');
            }
        })
    }

    getQuestionnaireChartReports() {
        this.loadingQuestionnaireText = "Loading...";
        if (this.selectedQuestionnaireChannel?.id) {
            this.appMainService.isShowSpinner('loadChartReports');
            this.reportService.AllQuestionareChartReport(this.selectedQuestionnaireChannel.id, this.formatDate(this.dateFrom), this.formatDate(this.dateTo)).then(res => {
                // console.log(res);
                const questionnaireChartData = res.contacts;
                if(questionnaireChartData?.questions?.length>0){
                    questionnaireChartData.questions.map(question=>{
                        question.responseCount = question.questionAns?.length||0;
                        question.totalresponsecount = question.responseCount||0;
                        question.questionOptions?.map(option=>{
                            option.answerValue = option.value;
                        });
                    })
                }
                this.questionnaireChartData = questionnaireChartData;
                this.appMainService.isHideSpinner('loadChartReports');
            }).catch(err => {
                this.loadingQuestionnaireText = "No Data Found";
                this.appMainService.isHideSpinner('loadChartReports');
            });
        }else{
            this.loadingQuestionnaireText = "No Data Found";
        }
    }

    getColor(index) {

        const colorList = ['#42A5F5', '#FFA726', '#7E57C2', '#26A69A'];

        if (index > 3) {
            let i = index % 3;
            return colorList[i];
        } else {
            return colorList[index];
        }
    }

    AllQuestionareReport(event: LazyLoadEvent, selectedWindow, selectedUser, selectedOrganizationId) {
        this.appMainService.isShowSpinner('GetAllQuestionareReport');
        const size = event.rows == undefined ? this.pageSize : event.rows;
        const pageNumber: number = event.rows == undefined ? 1 : ((event.first / event.rows) + 1);
        let userId = 0;
        selectedUser = { name: "", id: 0 };
        selectedUser = this.selectedRepFilter;
        userId = this.app.userId;

        this.QuestionareReport(0, this.app.companyId, userId, size, pageNumber, selectedWindow, selectedUser, selectedOrganizationId);
        this.appMainService.isHideSpinner('GetAllQuestionareReport');

    }

    QuestionareReport(selectedChannelId: number, companyId: number, userId, currentPageSize: number = 15, currentPageNumber: number = 1, selectedWindow: string, selectedUser: object, selectedOrganizationId: number, searchValue?: any) {

        this.appMainService.isShowSpinner('FieldVisitReport');

        this.OrganizationName = this.app.user.organizationName;
        this.reportService.AllQuestionareReport(selectedChannelId, currentPageSize, currentPageNumber, this.formatDate(this.dateFrom),
            this.formatDate(this.dateTo), this.selectedWindow,
            selectedUser, null, this.selectedDateCategoryFilter, this.selectedDateModuleFilter, this.selectedDateAccountNameFilter, this.selectedDateQuestionChannelfilter, searchValue).then(res => {

                this.results = [];
                this.totalRecords = 0;
                this.results = [];
                this.totalPages = 0;
                let { contacts, headers } = res;
                this.IsShowReportTemplate = true;
                this.appMainService.isHideSpinner('FieldVisitReport');

                this.results = JSON.parse(JSON.stringify(contacts));

                this.totalRecords = headers['TotalCount'];

                //added for PDF
                this.results = JSON.parse(JSON.stringify(contacts));
                this.totalPages = headers['TotalPages']
                //added for PDF

            }).finally(() => {
                this.appMainService.isHideSpinner('FieldVisitReport');
                this.noContactFindOrLoadingText = 'No Reports Available.';
            });
    }

    private formatDate(date: Date) {
        if (date)
            return moment(date).format('MM-DD-YYYY');
        else
            return null;
    }


    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }

    onClosePanel(selectedWindow: string): void {
    }

    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {

        if (this.selectedWindow == "qChannel") {
            selectedFilters.map(selectedFilter => {
                switch (selectedFilter.field) {
                    case "name":
                        this.selectedQuestionnaireChannel = this.allQuestionnaireChannels.find(channel => channel.id == selectedFilter.selectedId);
                        break;
                    default:
                        break
                }
            });

            this.getQuestionnaireChartReports();

        } else {
            const selectedUser = this.selectedRepFilter;
            this.QuestionareReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, selectedWindow, selectedUser, this.app.companyId);
        }
    }

    onChangeRange(selectedWindow: string, event: any): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        this.dateFilterLabel = event.selectedDateFilter.label;
        //this.selectedDateFilter = event;
        if (this.selectedWindow == "qChannel") {
            this.getQuestionnaireChartReports();
        } else {
            const selectedUser = this.selectedRepFilter;
            this.QuestionareReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, selectedWindow, selectedUser, this.app.companyId);
        }
    }

}
